import {
  CSSProperties,
  FC,
  forwardRef,
  ImgHTMLAttributes,
  LegacyRef,
  useEffect,
  useState,
} from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import "intersection-observer";
import "./Image.scss";
import config from "config";

interface ImageI extends ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  name?: string;
  ext?: "svg" | "png" | "jpg" | "gif" | "webp";
  style?: CSSProperties;
  hideTitle?: boolean;
}

const Image: FC<ImageI> = forwardRef(
  ({ src, name, ext = "svg", style, hideTitle, ...props }, ref) => {
    const [outerSrc, setOuterSrc] = useState("");
    const { getTextByKey } = useContent();
    useEffect(() => {
      if (name) {
        const imgPath = `${config.api.resource}/assets/images/${name}.${ext}`;
        setOuterSrc(imgPath);
      } else {
        setOuterSrc(src!);
      }
    }, [name, src]);

    const handleImageError = () => {
      if (src) {
        setOuterSrc(src);
      }
    };

    const getImageName = () => {
      if (name) {
        const fileName = name.split("/").pop();
        return getTextByKey("image-description-" + fileName);
      }
      return "";
    };

    return outerSrc ? (
      <img
        src={outerSrc}
        alt={getImageName()}
        title={hideTitle ? "" : getImageName()}
        style={style}
        {...{ ...props }}
        ref={ref as LegacyRef<HTMLImageElement> | undefined}
        onError={handleImageError}
      />
    ) : null;
  }
);

export default Image;
